import React, { useState, useEffect } from 'react';

interface TransitionProps {
  show: boolean;
  children: React.ReactNode;
  enter?: string;
  leave?: string;
  duration?: number;
}

const Transition: React.FC<TransitionProps> = ({
  show = true,
  children,
  enter = 'opacity-0 translate-y-4',
  leave = 'opacity-0 translate-y-4',
  duration = 300,
}) => {
  const [shouldRender, setShouldRender] = useState(show);
  const [animationClass, setAnimationClass] = useState(show ? '' : leave);

  useEffect(() => {
    if (show) {
      setShouldRender(true);
      // 给浏览器一帧时间来应用初始样式
      setTimeout(() => {
        setAnimationClass('');
      }, 10);
    } else {
      setAnimationClass(leave);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, leave, duration]);

  return shouldRender ? (
    <div
      className={`transition-all duration-${duration} ${animationClass}`}
      style={{ transitionDuration: `${duration}ms` }}
    >
      {children}
    </div>
  ) : null;
};

export default Transition; 